import 'angular:locale/data:en-US';
import './apps/client/src/polyfills.ts';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-US";
